import { render, staticRenderFns } from "./aftersale_visit_service_list.vue?vue&type=template&id=a173ab78&scoped=true"
import script from "./aftersale_visit_service_list.vue?vue&type=script&lang=js"
export * from "./aftersale_visit_service_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a173ab78",
  null
  
)

export default component.exports